module.exports = __webpack_public_path__ + "img/160.bbf48a83.jpg";